let _initProto, _initClass, _init_value, _init_extra_value, _init_label, _init_extra_label, _init_disabled, _init_extra_disabled, _init_selectionMode, _init_extra_selectionMode, _init_embedded, _init_extra_embedded, _init_changeEvent, _init_extra_changeEvent, _init_removeEvent, _init_extra_removeEvent, _init_managedItems, _init_extra_managedItems;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop, state } from "@ecopages/radiant";
import { navigateRovingTabindex } from "@/lib/roving-tabindex";
import { parseMultiValue, serializeMultiValue } from "../shared/multi-value";
let _RuiTagGroup;
class RuiTagGroup extends RadiantElement {
  static {
    ({
      e: [_init_value, _init_extra_value, _init_label, _init_extra_label, _init_disabled, _init_extra_disabled, _init_selectionMode, _init_extra_selectionMode, _init_embedded, _init_extra_embedded, _init_changeEvent, _init_extra_changeEvent, _init_removeEvent, _init_extra_removeEvent, _init_managedItems, _init_extra_managedItems, _initProto],
      c: [_RuiTagGroup, _initClass]
    } = _applyDecs(this, [customElement("rui-tag-group")], [[prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "value"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "disabled"], [prop({
      type: String,
      attribute: "selection-mode",
      defaultValue: "multiple"
    }), 0, "selectionMode"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "embedded"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [event({
      name: "rui-remove",
      bubbles: true,
      composed: true
    }), 0, "removeEvent"], [state, 0, "managedItems"], [onUpdated(["value", "label", "disabled", "selectionMode", "embedded", "managedItems"]), 2, "onPropsUpdated"], [onEvent({
      selector: "[data-tag]",
      type: "click"
    }), 2, "onTagClick"], [onEvent({
      selector: "[data-tag-remove]",
      type: "click"
    }), 2, "onRemoveClick"], [onEvent({
      selector: "[data-tag]",
      type: "keydown"
    }), 2, "onTagKeydown"]], 0, void 0, RadiantElement));
  }
  constructor(...args) {
    super(...args);
    _init_extra_managedItems(this);
  }
  value = (_initProto(this), _init_value(this));
  label = (_init_extra_value(this), _init_label(this));
  disabled = (_init_extra_label(this), _init_disabled(this));
  selectionMode = (_init_extra_disabled(this), _init_selectionMode(this));
  embedded = (_init_extra_selectionMode(this), _init_embedded(this));
  changeEvent = (_init_extra_embedded(this), _init_changeEvent(this));
  removeEvent = (_init_extra_changeEvent(this), _init_removeEvent(this));
  uid = (_init_extra_removeEvent(this), Math.random().toString(36).slice(2, 9));
  managedItems = _init_managedItems(this, []);
  isMultiple() {
    return this.selectionMode === "multiple";
  }
  getSelectedValues() {
    if (!this.value) {
      return [];
    }
    return parseMultiValue(this.value);
  }
  setSelectedValues(values) {
    this.value = serializeMultiValue(values);
  }
  getList() {
    const managed = this.querySelector("[data-rui-managed-list]");
    if (managed) {
      return managed;
    }
    return this.querySelector("[data-tag-list]");
  }
  getTags() {
    const list = this.getList();
    if (!list) {
      return [];
    }
    return Array.from(list.querySelectorAll("[data-tag]"));
  }
  getVisibleTags() {
    return this.getTags().filter(tag => !tag.hidden && tag.getAttribute("aria-disabled") !== "true");
  }
  getTagValue(tag) {
    return tag.getAttribute("data-value") || tag.textContent?.trim() || "";
  }
  getTagLabel(tag) {
    return tag.getAttribute("data-label") || tag.textContent?.trim() || "";
  }
  ensureTagIds() {
    this.getTags().forEach((tag, index) => {
      if (!tag.id) {
        tag.id = `rui-tag-${this.uid}-${index}`;
      }
    });
  }
  syncList() {
    const list = this.getList();
    if (!list) {
      return;
    }
    if (!list.id) {
      list.id = `rui-tag-list-${this.uid}`;
    }
    list.setAttribute("role", "list");
    list.setAttribute("aria-label", this.label || "Tags");
    if (this.disabled) {
      list.setAttribute("aria-disabled", "true");
    } else {
      list.removeAttribute("aria-disabled");
    }
  }
  syncTags() {
    const selected = new Set(this.getSelectedValues());
    const tags = this.getTags();
    tags.forEach((tag, index) => {
      tag.setAttribute("role", "listitem");
      const value = this.getTagValue(tag);
      const isSelected = selected.has(value);
      tag.setAttribute("aria-selected", String(isSelected));
      tag.tabIndex = index === 0 ? 0 : -1;
      const removeButton = tag.querySelector("[data-tag-remove]");
      if (removeButton) {
        removeButton.type = "button";
        removeButton.tabIndex = -1;
        removeButton.setAttribute("aria-label", `Remove ${this.getTagLabel(tag)}`);
      }
    });
  }
  selectTag(tag) {
    if (this.disabled || this.embedded || tag.getAttribute("aria-disabled") === "true") {
      return;
    }
    const tagValue = this.getTagValue(tag);
    if (this.isMultiple()) {
      const selected = new Set(this.getSelectedValues());
      if (selected.has(tagValue)) {
        selected.delete(tagValue);
      } else {
        selected.add(tagValue);
      }
      this.setSelectedValues([...selected]);
    } else {
      this.value = tagValue;
    }
    this.syncTags();
    this.changeEvent.emit({
      value: this.value
    });
  }
  removeTag(tag) {
    const tagValue = this.getTagValue(tag);
    const selected = new Set(this.getSelectedValues());
    selected.delete(tagValue);
    this.setSelectedValues([...selected]);
    this.syncTags();
    this.removeEvent.emit({
      value: tagValue
    });
    this.changeEvent.emit({
      value: this.value
    });
  }
  initialize() {
    this.ensureTagIds();
    this.syncList();
    this.syncTags();
  }
  onConnected() {
    this.initialize();
  }
  onPropsUpdated() {
    this.syncManagedList();
    this.syncList();
    this.syncTags();
  }
  resync() {
    this.ensureTagIds();
    this.syncList();
    this.syncTags();
  }
  setItems(items) {
    this.managedItems = items;
    this.value = serializeMultiValue(items.map(item => item.value));
  }
  /**
   * Imperative twin of the view's `RuiTag` / `RuiTagRemove` markup for
   * CE-managed items (same `data-*` hooks, classes, and remove glyph).
   */
  createManagedTag(item) {
    const tag = document.createElement("span");
    tag.setAttribute("data-tag", "");
    tag.setAttribute("data-value", item.value);
    tag.setAttribute("data-label", item.label);
    tag.className = "rui-tag";
    tag.textContent = item.label;
    const remove = document.createElement("button");
    remove.type = "button";
    remove.setAttribute("data-tag-remove", "");
    remove.className = "rui-tag__remove";
    remove.setAttribute("aria-label", `Remove ${item.label}`);
    const icon = document.createElement("span");
    icon.setAttribute("aria-hidden", "true");
    icon.textContent = "\xD7";
    remove.append(icon);
    tag.append(remove);
    return tag;
  }
  syncManagedList() {
    const root = this.querySelector('[data-ref="root"]');
    if (!root) {
      return;
    }
    let managed = root.querySelector("[data-rui-managed-list]");
    if (this.managedItems.length === 0) {
      managed?.remove();
      return;
    }
    if (!managed) {
      managed = document.createElement("div");
      managed.setAttribute("data-tag-list", "");
      managed.setAttribute("data-rui-managed-list", "");
      managed.className = "rui-tag-group__list";
      root.appendChild(managed);
    }
    managed.replaceChildren(...this.managedItems.map(item => this.createManagedTag(item)));
    this.ensureTagIds();
    this.syncList();
    this.syncTags();
  }
  onTagClick(event2) {
    const target = event2.target;
    if (target.closest("[data-tag-remove]")) {
      return;
    }
    const tag = target.closest("[data-tag]");
    if (tag && this.contains(tag)) {
      this.selectTag(tag);
    }
  }
  onRemoveClick(event2) {
    event2.stopPropagation();
    const button = event2.target;
    const tag = button.closest("[data-tag]");
    if (tag && this.contains(tag)) {
      this.removeTag(tag);
    }
  }
  onTagKeydown(event2) {
    const tags = this.getVisibleTags();
    const current = event2.target.closest("[data-tag]");
    if (!current) {
      return;
    }
    if (event2.key === "Enter" || event2.key === " ") {
      event2.preventDefault();
      if (!this.embedded) {
        this.selectTag(current);
      }
      return;
    }
    if (event2.key === "Backspace" || event2.key === "Delete") {
      const removeButton = current.querySelector("[data-tag-remove]");
      if (removeButton) {
        event2.preventDefault();
        this.removeTag(current);
      }
      return;
    }
    const result = navigateRovingTabindex({
      items: tags,
      current,
      key: event2.key,
      orientation: "horizontal"
    });
    if (result.handled) {
      event2.preventDefault();
    }
  }
  static {
    _initClass();
  }
}
export { _RuiTagGroup as RuiTagGroup };